import { BrowserStorage } from '@estee/elc-universal-utils';
import { action, computed } from 'mobx';

const SESSION_IDLE = 'session_idle';
const USER_ZIP_CODE = 'LOCATION+user_zip_code';
const USER_FULL_ADDRESS = 'LOCATION+user_full_address';
const IS_STORE_CHANGED = 'bopis-store-changed';
const EXPIRATION_TIME = 2 * 60 * 60000;
const GW_OPTED_OUT = 'gift_wrap_opted_out';

type zipStorage = {
  zip: string,
  expires: number;
};

export interface IUserAddress {
  administrative_area_level_1?: string;
  administrative_area_level_2?: string;
  country?: string;
  fullValue?: string;
  lat?: number;
  lng?: number;
  locality?: string;
  postal_code?: string;
  route?: string;
  street_number?: string;
}

class SessionRepository {
  setSessionIdle(timeout: number): void {
    BrowserStorage.setItem(SESSION_IDLE, String(timeout));
  }

  getSessionIdle(): number {
    const timeout = BrowserStorage.getItem(SESSION_IDLE);
    return Number(timeout);
  }

  deleteSessionIdle(): void {
    BrowserStorage.removeItem(SESSION_IDLE);
  }

  isStoreChanged(): boolean {
    return !!BrowserStorage.getItem(IS_STORE_CHANGED, 'sessionStorage');
  }

  isGiftWrapOptedOut(): boolean {
    return !!BrowserStorage.getItem(GW_OPTED_OUT, 'sessionStorage');
  }

  @computed
  get userLocalStorageZip(): string {
    let zipCode: string;

    try {
      const storage = BrowserStorage.getItem(USER_ZIP_CODE, 'localStorage');
      const parsedUserZipData: zipStorage = storage && JSON.parse(storage);
      const isNotExpired = parsedUserZipData?.expires > Date.now();
      zipCode = isNotExpired ? parsedUserZipData.zip : undefined;
    } catch (ex) {}

    return zipCode;
  }

  @computed
  get userAddress(): IUserAddress {
    const storage = BrowserStorage.getItem(USER_FULL_ADDRESS, 'localStorage');
    const parsedUserZipData = storage && JSON.parse(storage);

    return parsedUserZipData;
  }

  setUserLocalStorageZip = (zip: string): void => {
    const data = {
      expires: Date.now() + EXPIRATION_TIME,
      zip,
    };
    BrowserStorage.setItem(USER_ZIP_CODE, JSON.stringify(data), 'localStorage');
  };

  @action
  deleteUserLocalStorageZip = (): void => {
    BrowserStorage.removeItem(USER_ZIP_CODE, 'localStorage');
  };

  @action
  deleteUserLocalStorageAddress = (): void => {
    BrowserStorage.removeItem(USER_FULL_ADDRESS, 'localStorage');
  };

  @action
  deleteStoreChangedFlag = (): void => {
    BrowserStorage.removeItem(IS_STORE_CHANGED, 'sessionStorage');
  };

  @action
  setGiftWrapOptedOutFlag = (): void => {
    BrowserStorage.setItem(GW_OPTED_OUT, 'TRUE', 'sessionStorage');
  };
}

export default SessionRepository;
